// DetailSection — one card on a detail page: optional header and title, then exactly one of
// loading, error, empty or the content. Keeps every section's states the same.
import type { ReactNode } from "react";

interface DetailSectionProps {
  title?:     string;
  header?:    ReactNode;
  isLoading?: boolean;
  error?:     string | null | undefined;
  isEmpty?:   boolean;
  emptyText?: string;
  children:   ReactNode;
}

export default function DetailSection({ title, header, isLoading, error, isEmpty, emptyText, children }: DetailSectionProps) {
  let body: ReactNode = children;
  if (isLoading) body = <p className="text-sm text-dm-slate">Loading…</p>;
  else if (error) body = <p className="text-sm text-red-600">{error}</p>;
  else if (isEmpty) body = <p className="text-sm text-dm-slate">{emptyText ?? "Nothing here yet."}</p>;

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6">
      {header}
      {title && <h2 className="mb-4 text-lg font-medium text-dm-navy">{title}</h2>}
      {body}
    </div>
  );
}
